export default __webpack_public_path__ + "static/media/activate-staff.680ee991.png";